import { readStored, writeStored } from '@/lib/storage'
import { authStatus, readSession } from '@/lib/session'

/**
 * Yaş qapısı (veb TV) — backend-dəki `AgeGateRules`, saytdakı `lib/ageGate.ts`,
 * iOS `AgeGate.swift` və Android `AgeGate.kt` ilə EYNİ cədvəl.
 *
 * ⚠ TARİX GİRİŞİNİN TARİXÇƏSİ. 2026-08-05-də sahib TV-də tarix soruşulmamasını
 *   istəmişdi («tvdə isə modal sadəcə çıxsın və appda düzəlt bildirişi olsun») —
 *   qapı yalnız səbəbi göstərib istifadəçini tətbiqə/sayta yönləndirirdi.
 *   2026-08-07-də qərar DƏYİŞDİ (MYTasks 530: «saytda oldugu kimi düzəliş
 *   imkanı olsun»): tarix qeyd olunMAYIBSA modal pultla gün·ay·il seçicisi
 *   göstərir (`ui/detailModal.ts` → `openAgeBlocked`), tarix var amma yaş
 *   çatmırsa YALNIZ bildiriş qalır — server tarixi bir dəfə qəbul edir.
 *   Eyni dəyişiklik Android TV və Apple TV-də də edilib.
 *
 * ⚠ BU, TƏHLÜKƏSİZLİK SƏRHƏDİ DEYİL. Həqiqi qapı serverdədir: oynatma bileti
 *   `Playback.AgeRestricted` / `Playback.BirthDateRequired` qaytarır və manifest
 *   heç vaxt imzalanmır (`lib/playback.ts` → `status: 'age'`). Buradakı yoxlama
 *   YALNIZ səbəbi VAXTINDA — «İzlə» basılan anda — göstərmək üçündür.
 *
 * ⚠ ES2015 HƏDDİ (PERFORMANCE.md): `??`, `?.`, `Object.entries` YOXDUR — kod
 *   Chrome 53-də işləməlidir.
 */

/** Bu həddən aşağı kontentdə doğum tarixi soruşulmur. */
export var AGE_GATE_FROM = 18

/** Yaş yoxlamasının nəticəsi. */
export type AgeVerdict = 'allowed' | 'birthDate' | 'tooYoung'

/** Hesabın yaşı — `null` = ya çıxıb, ya da doğum tarixi qeyd olunmayıb. */
var accountAge: number | null = null
/**
 * Yaş UĞURLA alınıbmı — hər modal açılışında `/api/me` çağırılmasın.
 *
 * ⚠ CƏHDDƏ YOX, UĞURDA QALXIR (2026-08-08 düzəlişi, MYTasks 577). Əvvəl bayraq
 *   sorğudan ƏVVƏL qaldırılırdı: ilk `/api/me` şəbəkə tıqqıltısına düşsə yaş
 *   app-ın BÜTÜN ömrü boyu `null` qalırdı və hesabında doğum tarixi OLAN
 *   istifadəçi hər 18+ kontentdə «tarixinizi qeyd edin» seçicisini görürdü.
 *   Eyni düzəliş Android `AgeGateStore`-da da edildi.
 */
var loaded = false
/**
 * Serverin son yaş vəziyyətinin OPAK nişanı — long-poll-a `known=` kimi gedir.
 * Boş sətir = hələ heç nə alınmayıb (və ya server bu sahəni vermir).
 *
 * ⚠ CLIENT ONU AÇMIR, MÜQAYİSƏ ETMİR, SIRALAMIR — sadəcə serverə geri verir.
 *   Formatı (hash · ETag · sıra nömrəsi) serverin daxili işidir.
 */
var version = ''
/** Eyni anda gedən sorğular bir promise-ə yığılır (modal + hero eyni anda çağıra bilir). */
var inFlight: Promise<void> | null = null
/**
 * Hesab nəsli — `resetAge()` hər çağırılanda artır.
 *
 * ⚠ YOLDA QALAN CAVAB BAŞQA HESABA YAZILMASIN: QR ilə yeni hesab bağlananda
 *   köhnə sorğunun cavabı (long-poll 25 saniyəyə qədər açıq qala bilir) gec gəlib
 *   yeni istifadəçinin yaşını KÖHNƏ hesabın yaşı ilə əvəz edərdi.
 */
var epoch = 0
/** Canlı izləmə döngəsi (long-poll) işləyirmi. */
var watching = false
/** Yaş dəyişəndə xəbər verilən abunəçilər (film modalı hökmü yenidən verir). */
var listeners: Array<() => void> = []
/** Seçilmiş profil hesabda artıq yoxdur — giriş nöqtəsi «Kim baxır?»-a aparır. */
var profileGoneListener: (() => void) | null = null

/** Long-poll bir gedişdə serverdə nə qədər gözləsin (saniyə). */
var WAIT_SECONDS = 25
/**
 * Long-poll sorğusunun TRANSPORT həddi — serverin öz büdcəsindən 10 saniyə çox.
 *
 * ⚠ Ehtiyat pay olmasa cavab MƏHZ qayıdan anda kəsilərdi (Android
 *   `LONG_POLL_TIMEOUT_MARGIN_SECONDS` ilə eyni qərar).
 */
var WAIT_TIMEOUT_MS = (WAIT_SECONDS + 10) * 1000
/** Keçici xətadan sonra döngə nə qədər gözləsin — TV günlərlə açıq qalır. */
var WATCH_RETRY_MS = 15000
/** İki gediş arasındakı minimum məsafə (sıx döngə qoruyucusu — aşağıdakı izah). */
var WATCH_MIN_CYCLE_MS = 1000

/**
 * ANONİM istifadəçinin təsdiqlədiyi doğum tarixi — cihazda saxlanılır.
 *
 * ⚠ AÇAR SAYTLA EYNİDİR (`apps/web/src/lib/ageGate.ts` → `kb:birth-date`):
 *   veb səthlərində davranış eyni olsun. Telefon appdakı «hesabsız da qapını
 *   keçə bilsin» qərarının güzgüsüdür (Android `AgeGateStore.submitBirthDate`).
 * ⚠ HESAB DƏYƏRİ ÜSTÜNDÜR: sessiya varsa `/api/me`-dəki tarix işlədilir, lokal
 *   dəyər yalnız girişsiz halda oxunur — əks halda uşaq hesabı ilə girən
 *   istifadəçi cihazdakı «böyük» tarixlə qapını keçərdi.
 */
var LOCAL_BIRTH_DATE_KEY = 'kb:birth-date'

function readLocalBirthDate(): string | null {
  try {
    return window.localStorage.getItem(LOCAL_BIRTH_DATE_KEY)
  } catch {
    // TV-də storage bağlıdırsa qapı sadəcə hər dəfə soruşacaq.
    return null
  }
}

function writeLocalBirthDate(value: string): void {
  try {
    window.localStorage.setItem(LOCAL_BIRTH_DATE_KEY, value)
  } catch {
    // Saxlanmasa qapı növbəti açılışda yenidən soruşur — data itkisi deyil.
  }
}

interface MeResponse {
  profile?: { age?: number | null; birthDate?: string | null }
}

/**
 * `GET /api/me/age-state` (və onun long-poll əkizi) — MYTasks 577 müqaviləsi.
 *
 * ⚠ DÖRD CLIENT ÜÇÜN EYNİDİR (Android `AgeStateDto` · iOS · sayt): doğum tarixi,
 *   serverin hesabladığı yaş, baxış profillərinin yaş həddi və OPAK `version`.
 * ⚠ `profiles` BURADA OXUNMUR (qəsdən): lokal qapı YALNIZ hesabın yaşına baxır,
 *   profil limitini server tətbiq edir (`Playback.ProfileAgeRestricted`) və `0`/
 *   `null`-un «limitsiz» olub-olmadığı hələ ölçülməyib. Sahəni oxuyub istifadə
 *   etməmək ölü kod olardı — müqavilə sənədləşdirilir, qapıya bağlamaq ayrıca
 *   qərardır (Android tərəfdə də eyni qeyd var).
 * ⚠ `age` ÜSTÜNDÜR, `birthDate`-dən hesablanan yaşın YOX: ad günü sərhədi serverin
 *   saat qurşağında kəsilir, TV-nin saatı isə tez-tez səhv qurulur.
 */
interface AgeStateProfile {
  id?: string | null
  maxAgeRating?: number | null
  isKids?: boolean | null
}

interface AgeStateResponse {
  birthDate?: string | null
  age?: number | null
  version?: string | null
  profiles?: AgeStateProfile[] | null
}

/** `yyyy-mm-dd` → tam yaş. Səhv formatda `null`. */
export function ageFromBirthDate(raw: string | null | undefined): number | null {
  if (!raw || raw.length < 10) return null
  var parts = raw.slice(0, 10).split('-')
  if (parts.length !== 3) return null

  var year = Number(parts[0])
  var month = Number(parts[1])
  var day = Number(parts[2])
  if (!year || !month || !day) return null

  var today = new Date()
  var age = today.getFullYear() - year
  // Ad günü bu il hələ olmayıbsa bir yaş geri — bunsuz dekabrda doğulan
  // istifadəçi yanvarda bir yaş böyük görünür və hədd bir il tez açılır.
  var monthDiff = today.getMonth() + 1 - month
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < day)) age -= 1
  return age
}

/**
 * Hesabın yaşını bir dəfə çəkir. Xəta halında `accountAge` `null` qalır —
 * yəni qapı «doğum tarixi qeyd olunmayıb» deyir və seçici göstərilir.
 */
export function loadAgeIfNeeded(): Promise<void> {
  if (loaded) return Promise.resolve()
  return fetchAge()
}

/**
 * Yaşı SERVERDƏN İNDİ soruşur — keşə baxmadan (MYTasks 577).
 *
 * ⚠ NİYƏ `loadAgeIfNeeded`-dən ayrıca ad: onun bütün mənası «bir dəfə çək»dir,
 *   burada isə niyyət «köhnəlmiş ola bilər, təzələ»dir (app fona düşüb qayıdanda,
 *   long-poll ucu olmayan serverdə).
 */
export function refreshAge(): Promise<void> {
  return fetchAge()
}

/**
 * Yaşı çəkir — ÖNCƏ canlı uc (`/api/me/age-state`), o yoxdursa `/api/me`.
 *
 * ⚠ PARALEL ÇAĞIRIŞLAR BİR SORĞUYA YIĞILIR: modal, hero və izləmə döngəsi eyni
 *   anda çağıra bilir; üç `/api/me` TV-də üç boş gedişdir.
 * ⚠ XƏTADA `accountAge` SIFIRLANMIR (yalnız uğurda yazılır): qısa şəbəkə
 *   kəsintisi bütün kontenti «doğum tarixinizi qeyd edin» rejiminə salardı.
 */
function fetchAge(): Promise<void> {
  if (inFlight) return inFlight

  if (!readSession()) {
    // Girişsiz halda cihazda təsdiqlənmiş tarixə düşülür (saytdakı anonim yol) —
    // yoxdursa `null` qalır və qapı tarixi pultla soruşur (MYTasks 530).
    setAge(ageFromBirthDate(readLocalBirthDate()))
    loaded = true
    return Promise.resolve()
  }

  var asked = epoch
  inFlight = authStatus('/api/me/age-state')
    .then(function (response) {
      if (response.status >= 200 && response.status < 300 && applyStateText(response.text, asked)) return
      // Uc hələ yoxdur (404) və ya cavab oxunmadı → KÖHNƏ davranış: `/api/me`.
      return authStatus('/api/me').then(function (me) {
        if (asked !== epoch || me.status !== 200) return
        var data = JSON.parse(me.text) as MeResponse
        var profile = data && data.profile ? data.profile : null
        if (!profile) return
        setAge(typeof profile.age === 'number' ? profile.age : ageFromBirthDate(profile.birthDate))
        loaded = true
      })
    })
    .catch(function () {
      // Şəbəkə xətası — yaş bilinmir; server qapısı onsuz da öz işini görür.
    })
    .then(function () {
      // ⚠ YALNIZ ÖZ NÖVBƏSİNİ TƏMİZLƏYİR. `resetAge()` (çıxış · QR ilə yeni hesab)
      //   `inFlight`-i onsuz da boşaldır və ARDINCA yeni sorğu açıla bilir; şərtsiz
      //   `null` yazsaydıq bu gedişin gec gələn cavabı YENİ gedişin nişanını silərdi
      //   və növbəti `loadAgeIfNeeded()` eyni sorğunu ikinci dəfə göndərərdi
      //   (paralel çağırışları bir gedişə yığmağın bütün mənası itir).
      if (asked === epoch) inFlight = null
    })

  return inFlight
}

/** Cavab gövdəsini vəziyyətə yazır. `false` = oxunmadı/`version` yoxdur. */
function applyStateText(text: string, asked: number): boolean {
  var state: AgeStateResponse | null = null
  try {
    state = JSON.parse(text) as AgeStateResponse
  } catch {
    return false
  }
  if (!state) return false
  if (asked !== epoch) return true
  version = state.version || ''
  setAge(typeof state.age === 'number' ? state.age : ageFromBirthDate(state.birthDate))
  applyKidsLimit(state.profiles)
  loaded = true
  return true
}

/**
 * SEÇİLMİŞ PROFİLİN YAŞ HƏDDİNİ VƏZİYYƏTDƏN BƏRPA EDİR.
 *
 * ⚠⚠ NİYƏ BURADA, YALNIZ PROFİL SEÇİMİ EKRANINDA YOX (2026-08-26, canlıda ölçüldü):
 *    seçim ekranı həddi seçim anında yazır, amma ARTIQ SEÇİLMİŞ profil üçün heç nə
 *    yazılmır. Yəni bu buraxılışdan ƏVVƏL uşaq profilini seçmiş istifadəçi app-ı
 *    açanda süzgəcsiz kataloq görərdi — profili yenidən seçənə qədər. Yaş vəziyyəti
 *    onsuz da hər açılışda çəkilir (`startAgeWatch`), yəni bu bərpa PULSUZDUR.
 * ⚠ Sahə serverin `AgeStateDto.profiles` müqaviləsindəndir (dörd client üçün eyni).
 */
function applyKidsLimit(profiles: AgeStateProfile[] | null | undefined): void {
  if (!profiles || !profiles.length) return
  var selected = readStored('kb_tv_profile')
  if (!selected) return
  for (var i = 0; i < profiles.length; i++) {
    var p = profiles[i]
    if (!p || p.id !== selected) continue
    var limit = p.isKids ? (typeof p.maxAgeRating === 'number' ? p.maxAgeRating : 12) : null
    // 2026-10-11: disk yazısı rədd olunsa da canlı yaş yeniləməsi sorğulara çatmalıdır.
    writeStored('kb_tv_max_age', limit === null ? null : String(limit))
    if (limit === null) document.documentElement.removeAttribute('data-kids')
    else document.documentElement.setAttribute('data-kids', String(limit))
    return
  }
  /*
    2026-10-25, kod oxunuşu: SEÇİLMİŞ PROFİL SİYAHIDA YOXDUR — başqa cihazda silinib (server
      siyahısı hesabın BÜTÜN silinməmiş profilləridir, `UserReadQueries.GetAgeStateAsync`).
      ƏVVƏL seçim saxlancda qalırdı və hər bilet 404 `Profiles.NotFound` → «video hələ
      hazırlanmayıb» verirdi. İndi seçim, onun yaş həddi və adı silinir, giriş nöqtəsi
      «Kim baxır?»-a aparır. Açarlar birbaşa yazılır: `lib/profiles` bu modulu import edə
      bilər (dövrə), yuxarıdakı `kb_tv_max_age` yazısı ilə eyni səbəb.
  */
  writeStored('kb_tv_profile', null)
  writeStored('kb_tv_profile_name', null)
  writeStored('kb_tv_max_age', null)
  document.documentElement.removeAttribute('data-kids')
  if (profileGoneListener) profileGoneListener()
}

/** Seçilmiş profilin silindiyi aşkarlananda çağırılır (`main.ts` · `browser/main.ts`). */
export function onSelectedProfileGone(listener: () => void): void {
  profileGoneListener = listener
}

/** Yaşı yazır və DƏYİŞİBSƏ abunəçilərə xəbər verir. */
function setAge(next: number | null): void {
  if (accountAge === next) return
  accountAge = next
  for (var i = 0; i < listeners.length; i++) {
    var listener = listeners[i]
    if (!listener) continue
    try {
      listener()
    } catch (error) {
      // Bir abunəçinin xətası qapını və digərlərini öldürməməlidir.
      // eslint-disable-next-line no-console
      console.error('[tv] yaş dəyişikliyi işləyicisi xətası', error)
    }
  }
}

/**
 * Yaş dəyişəndə xəbər verilməsinə abunə olur.
 *
 * ⚠ ABUNƏNİN GÖTÜRÜLMƏSİ YOXDUR — qəsdən: yeganə abunəçi film modalıdır və o,
 *   app boyu TƏK nüsxədir (`ui/detailModal.ts` DOM-u bir dəfə qurulur). Ekran
 *   səviyyəsində abunə olsaydıq hər `mount`-da bir dinləyici sızardı.
 */
export function onAgeChange(listener: () => void): void {
  listeners.push(listener)
}

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * CANLI SİNXRON (MYTasks 577) — «vebdən/mobildən doğum tarixi dəyişəndə veb TV
 * DƏRHAL etkilənsin»
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * ⚠⚠ NİYƏ LONG-POLL, DÖVRİ TAYMER DEYİL: yaş ildə bir dəfə dəyişən dəyərdir —
 *   dövri sorğu praktiki olaraq HƏMİŞƏ eyni cavabı gətirər, TV isə günlərlə açıq
 *   qalır (minlərlə boş gediş, hər biri əsas axında JSON parse). Long-poll-da
 *   bağlantı SERVERDƏ gözləyir və cavab məhz dəyişiklik anında gəlir.
 * ⚠ UC HƏLƏ YOXDURSA (404 · `version` boş) DÖNGƏ SƏSSİZCƏ DAYANIR və köhnə
 *   davranış qalır (bir dəfəlik `/api/me`). İstifadəçiyə heç bir xəta
 *   göstərilmir — bu, onun görməli olduğu hadisə deyil.
 * ⚠ SIX DÖNGƏ QORUYUCUSU: `version` boş qalırsa (köhnə API binarı sahəni vermir)
 *   döngə dərhal dayanır, əks halda hər cavab dərhal qayıdıb saniyədə onlarla
 *   sorğuya çevrilərdi (backend-də ölçülmüş `party-invites` insidenti).
 * ⚠ ÇIXIŞDA/HESAB DƏYİŞƏNDƏ döngə `readSession()` yoxlaması ilə özü dayanır;
 *   yenidən başlatmaq çağıranın işidir (`main.ts` → QR callback-i).
 */
export function startAgeWatch(): void {
  if (watching || !readSession()) return
  watching = true
  var asked = epoch

  var stop = function (): void {
    watching = false
  }

  var again = function (delay: number): void {
    window.setTimeout(function () {
      if (!watching || asked !== epoch) return
      step()
    }, delay)
  }

  var step = function (): void {
    if (!watching || asked !== epoch) return
    if (!readSession()) {
      stop()
      return
    }

    var startedAt = Date.now()
    // İlk gediş (və `version` itəndən sonrakı) ADİ sorğudur — nişanı gətirir.
    var pending = version
      ? authStatus(
          '/api/me/age-state/wait?known=' + encodeURIComponent(version) + '&timeoutSeconds=' + WAIT_SECONDS,
          { timeoutMs: WAIT_TIMEOUT_MS },
        )
      : authStatus('/api/me/age-state')

    pending.then(
      function (response) {
        if (!watching || asked !== epoch) return
        // Uc yoxdur (404) və ya sessiya bitib (401/403) → köhnə davranışa qayıdırıq.
        if (response.status === 404 || response.status === 401 || response.status === 403) {
          stop()
          void loadAgeIfNeeded()
          return
        }
        if (response.status < 200 || response.status >= 300) {
          again(WATCH_RETRY_MS)
          return
        }
        if (!applyStateText(response.text, asked) || !version) {
          // Cavab oxunmadı və ya `version` yoxdur — nişansız long-poll sıx döngədir.
          stop()
          return
        }
        /**
         * ⚠ DÖVRƏNİN ALT HƏDDİ VAR. Normal halda server cavabı `WAIT_SECONDS`
         *   saxlayır, yəni gecikmə sıfırdır. Amma səhv qurulmuş/köhnə server
         *   (və ya araya girən proxy) cavabı DƏRHAL qaytarsa bu döngə saniyədə
         *   onlarla sorğuya çevrilərdi — backend-də ölçülmüş `party-invites`
         *   insidenti (2026-07-30) məhz belə yaranmışdı. Hədd cihaz başına ən
         *   çox 1 sorğu/saniyə deməkdir.
         */
        var elapsed = Date.now() - startedAt
        again(elapsed >= WATCH_MIN_CYCLE_MS ? 0 : WATCH_MIN_CYCLE_MS - elapsed)
      },
      function () {
        if (!watching || asked !== epoch) return
        // Şəbəkə/timeout — sessiya sağdır, sadəcə gediş alınmadı.
        again(WATCH_RETRY_MS)
      },
    )
  }

  step()
}

/**
 * Hesabın yaşı yenidən oxunsun (giriş/çıxışdan sonra).
 *
 * ⚠ NİŞAN DA SİLİNİR: başqa hesabın `version`-u ilə long-poll atılsaydı server ya
 *   404, ya da YAD hesabın vəziyyətini qaytarardı (Android `AgeGateStore.clear`
 *   ilə eyni qərar).
 * ⚠ NƏSİL ARTIR: yolda qalan köhnə cavab yeni hesabın yaşına yazılmır və
 *   köhnə izləmə döngəsi növbəti addımda özü dayanır.
 */
export function resetAge(): void {
  epoch += 1
  loaded = false
  version = ''
  inFlight = null
  watching = false
  setAge(null)
}

/**
 * @param ageLimit Kontentin yaş həddi (0/6/12/16/18/21) — bilinmirsə `null`.
 *
 * ⚠⚠ GİRİŞ YOXDURSA YAŞ ÜMUMİYYƏTLƏ YOXLANILMIR (sahib tələbi 2026-08-08:
 *   «projelərdə login olmayıbsa yaş yoxlaması edilməsin. bütün projelərdə») —
 *   2026-08-05 qərarının geri alınmasıdır. Veb TV-də app onsuz da QR girişinin
 *   arxasındadır, yəni praktikada bu budaq yalnız sessiya bitəndə işə düşür;
 *   qayda buna baxmayaraq yazılır ki, dörd səthin məntiqi eyni qalsın.
 * ⚠ Server qapısı toxunulmazdır (`lib/playback.ts` → `status: 'age'`).
 */
export function evaluateAge(ageLimit: number | null): AgeVerdict {
  if (!readSession()) return 'allowed'
  if (!ageLimit || ageLimit < AGE_GATE_FROM) return 'allowed'
  if (accountAge === null) return 'birthDate'
  return accountAge >= ageLimit ? 'allowed' : 'tooYoung'
}

/**
 * Bu kontentin treyleri İNDİ ÖZ-ÖZÜNƏ oynaya bilərmi — hero · kart önizləməsi · sonluq qatı ·
 * modalın fon treyleri · tam ekran treyler (saytdakı `lib/ageGate.ts` → `trailerAllowed` ilə
 * EYNİ qayda). Klik qapısı isə `evaluateAge` olaraq qalır.
 *
 * ⚠⚠ 2026-10-25, kod oxunuşu: TV-də treyler yolları `evaluateAge`-ə baxırdı, o isə girişsiz
 *    baxana HƏMİŞƏ `allowed` deyir (2026-08-08 klik qaydası) — 18+ kart önizləməsi, sonluq
 *    önizləməsi və modalın treyleri girişsiz oynayırdı; brauzer hero-su isə ümumiyyətlə
 *    yoxlanmırdı. Sayt 2026-10-25-də eyni qüsuru bağlayıb.
 * Qayda: profil həddi əvvəl (həddi aşan kontent heç vaxt); 18-dən aşağı — oynayır; 18+ —
 * yalnız giriş VAR, yaş YÜKLƏNİB və hökm `allowed` olanda. Yaş hələ gəlməyibsə oynamır.
 */
export function trailerAllowed(ageLimit: number | null | undefined): boolean {
  var limit = typeof ageLimit === 'number' && ageLimit > 0 ? ageLimit : 0
  var cap = parseInt(readStored('kb_tv_max_age') || '', 10)
  if (isFinite(cap) && limit > cap) return false
  if (limit < AGE_GATE_FROM) return true
  if (!readSession() || !loaded) return false
  return evaluateAge(limit) === 'allowed'
}

/**
 * Seçicidən təsdiqlənən tarixi yazır — Android `AgeGateStore.submitBirthDate`-in
 * güzgüsü («hesabsız da qapını keçə bilsin» qərarı, `AgeGate.kt`):
 *   · sessiya varsa `PUT /api/me/birth-date` (saytdakı `lib/me.ts` →
 *     `setBirthDate` ilə eyni gövdə: `{ birthDate }`). Server tarixi BİR DƏFƏ
 *     qəbul edir — mövcud tarixin üstünə yazmaq 409 qaytarır; o halda yaş serverdən
 *     yenidən oxunur və oxunubsa `true` (aşağıdakı 2026-10-23 qeydi);
 *   · sessiya yoxdursa tarix cihazda saxlanılır (saytın anonim yolu ilə eyni).
 *
 * Uğurda `accountAge` DƏRHAL yenilənir ki, modal serveri təkrar soruşmadan
 * hökm verə bilsin; lokal nüsxə hər iki halda yazılır (Android ilə eyni —
 * çıxışdan sonra da qapı eyni cavabı versin).
 */
export function saveBirthDate(iso: string): Promise<boolean> {
  if (!readSession()) {
    writeLocalBirthDate(iso)
    setAge(ageFromBirthDate(iso))
    loaded = true
    return Promise.resolve(true)
  }

  return authStatus('/api/me/birth-date', {
    method: 'PUT',
    body: JSON.stringify({ birthDate: iso }),
  })
    .then(function (response): boolean | Promise<boolean> {
      /*
        2026-10-23: 409 «TARİX ARTIQ VAR» UĞURDUR — yaş serverdən yenidən oxunur.
          NƏ TAPILDI: veb TV-də qapı yaş vəziyyəti yüklənməmiş hökm verirdi və doğum
          tarixi OLAN hesaba seçici göstərirdi; təsdiq `PUT` 409 (`Users.BirthDateAlreadySet`)
          alırdı və `false` qayıdırdı.
          ƏVVƏL: «Tarix qeyd olunmadı», 18+ film («Pərdə») heç vaxt açılmırdı — istifadəçinin
          edə biləcəyi heç nə qalmırdı.
          NİYƏ BELƏ: 409 hesabda tarix olduğunu SÜBUT EDİR; doğru hökm üçün həmin tarix
          lazımdır, ona görə `refreshAge` ilə oxunur. Oxuna bilməsə (şəbəkə) `false` qalır
          və seçici xəta mətnini göstərir. Uşaq yaşı da beləcə düzgün `tooYoung` olur.
      */
      if (response.status === 409) {
        return refreshAge().then(function () {
          return accountAge !== null
        })
      }
      if (response.status < 200 || response.status >= 300) return false
      // ⚠ `setAge` — modal hökmü elə bu andaca yenidən verə bilsin (MYTasks 577
      //   abunə mexanizmi); dəyər dəyişməyibsə heç kim oyanmır.
      setAge(ageFromBirthDate(iso))
      loaded = true
      writeLocalBirthDate(iso)
      return true
    })
    .catch(function () {
      // Şəbəkə xətası — modal xəta mətnini göstərir, giriş sahəsi qalır.
      return false
    })
}
